import React from 'react';
import { Shield } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`relative group inline-flex items-center justify-center gap-3 px-8 py-4 bg-bio-amber text-bio-black font-oswald text-xl uppercase tracking-[0.15em] font-bold overflow-hidden transition-all hover:bg-bio-amberHover box-glow-amber ${className}`} {...props} data-id="element-280">
      {/* Tactical corner accents */}
      <div className="absolute top-1 left-1 w-2 h-2 border-t-2 border-l-2 border-bio-black/50" data-id="element-281" />
      <div className="absolute bottom-1 right-1 w-2 h-2 border-b-2 border-r-2 border-bio-black/50" data-id="element-282" />

      <Shield className="w-5 h-5 shrink-0" data-id="element-283" />
      <span className="relative z-10 flex flex-col items-center leading-[1.1]" data-id="element-284">
        {children}
      </span>

      {/* Hover scanline effect */}
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-285" />
    </button>;
}